import { assertEvent, assign } from 'xstate5';

import { addModificationToActiveModificationsList } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the addition of a modification to the list of active modifications
 * within the customization context.
 */
export const addModification: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, [
    'customization.add-modification',
    'customization.dressing.increase-portions',
  ]);

  const { allModificationsMap, modifications } = context;
  const { ingredientId } = event;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const updatedActives = addModificationToActiveModificationsList(
    ingredientId,
    active,
    allModificationsMap,
  );

  return { modifications: { ...modifications, active: updatedActives } };
});
